import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ASK_KEY, enablePrintPush, notifyState } from "@/lib/printPush";

export function PrintNotifyPrompt({ central }) {
  const [open, setOpen] = useState(() => notifyState() === "default" && !localStorage.getItem(ASK_KEY));
  const [busy, setBusy] = useState(false);
  const close = (v) => { localStorage.setItem(ASK_KEY, v); setOpen(false); };
  const enable = async () => {
    setBusy(true);
    try {
      await enablePrintPush(central);
      toast.success("Avisos ativados neste computador");
      close("yes");
    } catch (e) {
      toast.error(e.message);
      if (notifyState() !== "default") close("no");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) close("later"); }}>
      <DialogContent className="max-w-md" data-testid="print-notify-prompt">
        <DialogHeader>
          <span className="mb-2 flex h-11 w-11 items-center justify-center rounded-full bg-primary/10 text-primary"><BellRing className="h-5 w-5" /></span>
          <DialogTitle>Ativar avisos de novos pedidos?</DialogTitle>
          <DialogDescription>
            Com os avisos ligados, este computador imprime e avisa cada pedido novo mesmo com o sistema minimizado ou em outra aba.
            Se a impressora não responder, aparece uma notificação com o botão <b>Imprimir agora</b>.
          </DialogDescription>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">Depois de clicar em Ativar avisos, o navegador vai perguntar: escolha <b>Permitir</b>. Dá para mudar depois em Configurações → Impressão.</p>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="ghost" onClick={() => close("later")} data-testid="print-notify-later-btn">Agora não</Button>
          <Button onClick={enable} disabled={busy} data-testid="print-notify-enable-btn">Ativar avisos</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
